import type { PayContract } from "@haulsheet/core";
import { getDb } from "./dexie";

/**
 * The contract new checks use: the most recently updated active, non-deleted
 * contract. Ties (rows written in one server transaction share updated_at)
 * break on createdAt, then id, so every screen and device picks the same one.
 */
export function pickActiveContract(
  contracts: readonly PayContract[],
): PayContract | null {
  let best: PayContract | null = null;
  for (const c of contracts) {
    if (!c.active || c.deletedAt != null) continue;
    if (!best || compareRecency(c, best) > 0) best = c;
  }
  return best;
}

function compareRecency(a: PayContract, b: PayContract): number {
  return (
    a.updatedAt.localeCompare(b.updatedAt) ||
    a.createdAt.localeCompare(b.createdAt) ||
    a.id.localeCompare(b.id)
  );
}

/** A load's own contract when it has one (e.g. imported Bennett loads), else the active pick. */
export function contractForLoad(
  load: { payContractId: string | null },
  contracts: readonly PayContract[],
): PayContract | null {
  if (load.payContractId) {
    const own = contracts.find((c) => c.id === load.payContractId);
    if (own) return own;
  }
  return pickActiveContract(contracts);
}

export async function loadActiveContract(): Promise<PayContract | null> {
  return pickActiveContract(await getDb().pay_contract.toArray());
}
